import { createContext } from "react"
import { Justify } from "./types"

export const SectionContext = createContext({
    justify: "left" as Justify,
})
